import { render, staticRenderFns } from "./domaine-vincent-dauvissat.vue?vue&type=template&id=2916693a&scoped=true"
import script from "./domaine-vincent-dauvissat.vue?vue&type=script&lang=js"
export * from "./domaine-vincent-dauvissat.vue?vue&type=script&lang=js"
import style0 from "./domaine-vincent-dauvissat.vue?vue&type=style&index=0&id=2916693a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916693a",
  null
  
)

export default component.exports